import React from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
	return (
		<navbar className="center">
			<div className="scroll-up-btn">
				<a href="#home">
					<i className="fas fa-angle-up" />
				</a>
			</div>
			<nav className="navbar">
				<div className="max-width">
					<div className="menu-btn">
						<i className="fas fa-bars" />
					</div>
					<div className="logo">
						<Link to="/">Panwar Chikitsa Kendra</Link>
					</div>
					<div className="logo-mob">
						<Link to="/">Dr. IP Singh</Link>
					</div>
					<span id="clickableAwesomeFont" className="btn-toggle">
						<i id="darkMode" class="fas fa-moon" />
					</span>
					<ul className="menu">
						<li>
							<Link to="/home" className="menu-btn">
								Home
							</Link>
						</li>
						<li>
							<Link to="/about" className="menu-btn">
								About
							</Link>
						</li>
						{/* <li><Link to="/experience" className="menu-btn">Experience</Link></li>*/}
						<li>
							<Link to="/clinic" className="menu-btn">
								Clinic
							</Link>
						</li>
						<li>
							<Link to="/services" className="menu-btn">
								Services
							</Link>
						</li>
						<li>
							<Link to="/skills" className="menu-btn">
								Expertise
							</Link>
						</li>
						<li>
							<Link to="/facilities" className="menu-btn">
								Facilities
							</Link>
						</li>
						<li>
							<Link to="/contact" className="menu-btn">
								Contact
							</Link>
						</li>
					</ul>
				</div>
			</nav>
		</navbar>
	);
};

export default Navbar;
